// extracted by mini-css-extract-plugin
export default {"table":"AssignedTable_table__VP88r","title-header":"AssignedTable_title-header__NoT-h","status":"AssignedTable_status__5XYbE","title":"AssignedTable_title__oiiPK"};